/* Siebdruck-Beutel: Motiv-Vorschau, Vorne/Hinten, Motiv verschieben + Größe (Boards 231 B, 232 A, 233 A), 14.10.2026 */
(function () {
  var T = window.SD_MOTIV_T || {};
  var ICON = '<span class="sd-upa__ic" aria-hidden="true"><svg viewBox="0 0 48 48" width="48" height="48"><path d="M18 4v10M30 4v10" stroke="#8A928E" stroke-width="2.5" fill="none"/><rect x="8" y="14" width="32" height="30" rx="2" fill="#FFFFFF" stroke="#111111" stroke-width="1.2"/><rect x="15" y="21" width="18" height="18" fill="rgba(120,230,208,.5)" stroke="#111111" stroke-width="1" stroke-dasharray="2.5 2"/></svg></span>';
  var fmt = function (v) { v = Math.round(v * 2) / 2; return String(v).replace('.', ','); };
  function init() {
    var root = document.querySelector('[data-sd-pdp]'); if (!root) return;
    var main = root.querySelector('[data-sd-main]'), pa = root.querySelector('[data-sd-pa]');
    var inpF = root.querySelector('[data-sd-file="f"]'), uplF = root.querySelector('[data-sd-upl="f"]');
    if (!main || !pa || !inpF || !uplF || root.querySelector('.sd-upa')) return;
    var inpB = root.querySelector('[data-sd-file="b"]'), uplB = root.querySelector('[data-sd-upl="b"]');
    var backCard = root.querySelector('[data-sd-back]'), backSw = root.querySelector('[data-sd-backsw]');
    var tog = root.querySelector('[data-sd-patog]'), later = root.querySelector('[data-sd-later]'), lbl = pa.querySelector('.sd-pa__lbl');
    var mainImg = main.querySelector('img:not([data-sd-ov])'); if (mainImg) mainImg.classList.add('sd-mainimg');
    var lblDef = lbl ? lbl.textContent : T.area;
    var hasBack = !!(backCard && !backCard.hidden && backSw && inpB && uplB);
    function mkState() { return { url: '', img: false, ratio: 0, file: false, w: 0, x: 0, y: 0, ytxt: '', ui: null }; }
    var S = { side: 'v', dragged: false, f: mkState(), b: mkState() };

    function dims() {
      var w = pa.querySelector('[data-sd-pa-w]'), h = pa.querySelector('[data-sd-pa-h]');
      return [parseFloat(String(w ? w.textContent : '0').replace(',', '.')) || 0, parseFloat(String(h ? h.textContent : '0').replace(',', '.')) || 0];
    }
    function hOf(st) { return st.img && st.ratio ? st.w / st.ratio : 0; }
    function wMax(st) { var d = dims(); return st.img && st.ratio ? Math.min(d[0], d[1] * st.ratio) : d[0]; }
    function wMin(st) { return Math.min(5, Math.max(1, Math.round(wMax(st) * 0.3))); }
    function clamp(st) {
      var d = dims(), mx = wMax(st), mn = wMin(st);
      st.w = Math.max(mn, Math.min(mx, st.w || mx));
      st.x = Math.max(0, Math.min(d[0] - st.w, st.x));
      st.y = Math.max(0, Math.min(d[1] - hOf(st), st.y));
    }
    function preset(st, p) {
      var d = dims(), h = hOf(st);
      st.x = (d[0] - st.w) / 2;
      if (st.img) { st.y = p === 'top' ? 0 : p === 'bot' ? d[1] - h : (d[1] - h) / 2; st.ytxt = ''; }
      else { st.ytxt = p; st.y = p === 'top' ? 0 : st.y; }
      st.pre = p;
    }
    function resetSt(st) { var d = dims(); st.w = st.img ? wMax(st) : Math.min(d[0], 10); st.x = 0; st.y = 0; clamp(st); preset(st, 'mid'); }
    function desc(st) {
      var d = dims(), parts = [];
      parts.push(st.img && st.ratio ? fmt(st.w) + ' × ' + fmt(hOf(st)) + ' cm' : fmt(st.w) + ' cm ' + T.wide);
      if (st.img || !st.ytxt) parts.push(fmt(st.y) + ' ' + T.below);
      else parts.push(st.ytxt === 'top' ? T.vTop : st.ytxt === 'bot' ? T.vBot : T.vMid);
      var cx = st.x + st.w / 2;
      parts.push(Math.abs(cx - d[0] / 2) < 0.3 ? T.centered : fmt(st.x) + ' ' + T.fromleft);
      return parts.join(' · ');
    }

    // Hinweis im Motiv-Schritt
    var box = document.createElement('div'); box.className = 'sd-upa';
    box.innerHTML = ICON + '<span class="sd-upa__t"><strong class="sd-subhead"></strong><span class="sd-body"></span></span>';
    box.querySelector('.sd-body').textContent = T.hint;
    uplF.parentNode.insertBefore(box, uplF);

    // Steuerung je Seite
    function mkUi(upl, propName) {
      var c = document.createElement('div'); c.className = 'sd-pos'; c.hidden = true;
      c.innerHTML = '<div class="sd-pos__row"><span class="sd-subhead"></span><button type="button" class="sd-pos__reset"></button></div>' +
        '<div data-m="img"><div class="sd-pos__row"><span class="sd-body"></span><strong class="sd-body" data-wv></strong></div>' +
        '<input type="range" class="sd-pos__rng" step="0.5"><div class="sd-pos__row"><span class="sd-pos__mm" data-min></span><span class="sd-pos__mm" data-max></span></div></div>' +
        '<div data-m="pdf" class="sd-pos__nums"><label><span data-l="w"></span><input type="number" inputmode="decimal" step="0.5" data-n="w"><span>cm</span></label><label><span data-l="y"></span><input type="number" inputmode="decimal" step="0.5" data-n="y"><span>cm</span></label></div>' +
        '<div class="sd-pos__pills"><button type="button" data-p="top"></button><button type="button" data-p="mid"></button><button type="button" data-p="bot"></button></div>' +
        '<p class="sd-pos__read sd-body"></p><p class="sd-pos__info sd-body"></p>' +
        '<input type="hidden" disabled>';
      c.querySelector('.sd-subhead').textContent = T.pos;
      c.querySelector('.sd-pos__reset').textContent = T.reset;
      c.querySelector('[data-m="img"] .sd-body').textContent = T.width;
      c.querySelector('[data-l="w"]').textContent = T.width;
      c.querySelector('[data-l="y"]').textContent = T.top;
      c.querySelector('[data-p="top"]').textContent = T.pTop;
      c.querySelector('[data-p="mid"]').textContent = T.pMid;
      c.querySelector('[data-p="bot"]').textContent = T.pBot;
      var hid = c.querySelector('input[type="hidden"]'); hid.name = 'properties[' + propName + ']';
      upl.parentNode.insertBefore(c, upl.nextSibling);
      return { c: c, rng: c.querySelector('.sd-pos__rng'), wv: c.querySelector('[data-wv]'), mn: c.querySelector('[data-min]'), mx: c.querySelector('[data-max]'),
        img: c.querySelector('[data-m="img"]'), pdf: c.querySelector('[data-m="pdf"]'), nw: c.querySelector('[data-n="w"]'), ny: c.querySelector('[data-n="y"]'),
        pills: c.querySelectorAll('[data-p]'), read: c.querySelector('.sd-pos__read'), info: c.querySelector('.sd-pos__info'), hid: hid, reset: c.querySelector('.sd-pos__reset') };
    }
    S.f.ui = mkUi(uplF, T.propF);
    if (hasBack) S.b.ui = mkUi(uplB, T.propB);

    // Motiv im Bild
    var mv = document.createElement('div'); mv.className = 'sd-mv'; mv.hidden = true;
    mv.innerHTML = '<img alt=""><span class="sd-mv__h" aria-hidden="true"></span>';
    var mvImg = mv.querySelector('img'), mvH = mv.querySelector('.sd-mv__h');
    pa.appendChild(mv);
    var guide = document.createElement('span'); guide.className = 'sd-guide'; guide.hidden = true; pa.appendChild(guide);
    var dh = document.createElement('span'); dh.className = 'sd-dhint'; dh.hidden = true; dh.textContent = '✥ ' + T.drag; main.appendChild(dh);

    function backOn() { return hasBack && backSw.getAttribute('aria-checked') === 'true'; }
    var seg = null, bV = null, bH = null, dotH = null;
    if (hasBack) {
      seg = document.createElement('div'); seg.className = 'sd-vseg'; seg.setAttribute('role', 'group'); seg.setAttribute('aria-label', T.view);
      seg.innerHTML = '<button type="button" aria-pressed="true"><i></i><span></span></button><button type="button" aria-pressed="false"><i></i><span></span></button>';
      bV = seg.children[0]; bH = seg.children[1];
      bV.querySelector('span').textContent = T.front; bH.querySelector('span').textContent = T.back;
      dotH = bH.querySelector('i');
      main.appendChild(seg);
      bV.addEventListener('click', function () { setSide('v'); });
      bH.addEventListener('click', function () { setSide('h'); });
    }
    function blankImg() {
      var sw = root.querySelector('[data-sd-sw][aria-pressed="true"]') || root.querySelector('[data-sd-sw]');
      if (sw && sw.getAttribute('data-img') && mainImg && (mainImg.currentSrc || mainImg.src).indexOf(sw.getAttribute('data-img').split('?')[0].split('/').pop().split('_1200x')[0]) < 0) sw.click();
    }
    function showPa() { if (tog && tog.getAttribute('aria-pressed') !== 'true') tog.click(); else pa.hidden = false; }
    function cur() { return S.side === 'h' ? S.b : S.f; }

    function renderUi(st, on) {
      var u = st.ui; if (!u) return;
      var d = dims();
      u.c.hidden = !(st.file && on);
      u.hid.disabled = !(st.file && on);
      if (!st.file) return;
      u.img.hidden = !st.img; u.pdf.hidden = st.img;
      if (st.img) {
        var mn = wMin(st), mx = wMax(st);
        u.rng.min = mn; u.rng.max = mx; u.rng.value = st.w;
        u.wv.textContent = fmt(st.w) + ' cm';
        u.mn.textContent = fmt(mn) + ' cm'; u.mx.textContent = fmt(mx) + ' cm · ' + T.full;
      } else {
        if (document.activeElement !== u.nw) u.nw.value = fmt(st.w).replace(',', '.');
        if (document.activeElement !== u.ny) u.ny.value = st.ytxt ? '' : fmt(st.y).replace(',', '.');
        u.nw.max = d[0]; u.ny.max = d[1];
      }
      Array.prototype.forEach.call(u.pills, function (b) { b.setAttribute('aria-pressed', st.pre === b.getAttribute('data-p') ? 'true' : 'false'); });
      var txt = desc(st);
      u.read.textContent = T.yours + ' ' + txt;
      u.info.textContent = st.img ? T.info : T.infoPdf;
      u.hid.value = txt;
    }
    function render() {
      var back = S.side === 'h', st = cur(), on = back ? backOn() : true, d = dims();
      main.classList.toggle('sd-is-back', back);
      if (bV) { bV.setAttribute('aria-pressed', back ? 'false' : 'true'); bH.setAttribute('aria-pressed', back ? 'true' : 'false'); dotH.classList.toggle('is-off', !backOn()); }
      [S.f, S.b].forEach(function (s) { if (s.file) clamp(s); });
      var showMv = !!(st.url && st.img && st.ratio && on && d[0] && d[1]);
      if (showMv) {
        if (mvImg.getAttribute('src') !== st.url) mvImg.src = st.url;
        mv.style.left = (st.x / d[0] * 100) + '%'; mv.style.top = (st.y / d[1] * 100) + '%';
        mv.style.width = (st.w / d[0] * 100) + '%'; mv.style.height = (hOf(st) / d[1] * 100) + '%';
      }
      mv.hidden = !showMv; dh.hidden = !showMv || S.dragged;
      pa.classList.toggle('has-mot', showMv);
      root.classList.toggle('sd-has-mot', !back && S.f.img && !!S.f.url);
      pa.classList.toggle('is-off', back && !on);
      var size = st.file && on ? ' · ' + (st.img && st.ratio ? fmt(st.w) + ' × ' + fmt(hOf(st)) + ' cm' : fmt(st.w) + ' cm') : '';
      if (lbl) lbl.textContent = back ? (!on ? T.bOff : (st.file ? T.bMot + size : T.bArea)) : (S.f.file ? T.mot + size : lblDef);
      box.querySelector('.sd-subhead').textContent = T.area + ' ' + T.upto + ' ' + d[0] + ' × ' + d[1] + ' cm';
      renderUi(S.f, true); if (hasBack) renderUi(S.b, backOn());
    }
    function setSide(s) {
      if (!hasBack) s = 'v';
      S.side = s;
      if (s === 'h') { blankImg(); setTimeout(showPa, 0); }
      render();
    }

    // Bedienung Regler, Felder, Schnellwahl
    function bindUi(st, side) {
      var u = st.ui; if (!u) return;
      u.rng.addEventListener('input', function () {
        var cx = st.x + st.w / 2, cy = st.y + hOf(st) / 2;
        st.w = parseFloat(u.rng.value) || st.w; st.x = cx - st.w / 2; st.y = cy - hOf(st) / 2; st.pre = '';
        if (S.side !== side) setSide(side); else render();
      });
      u.nw.addEventListener('input', function () { var v = parseFloat(String(u.nw.value).replace(',', '.')); if (v > 0) { st.w = v; render(); } });
      u.ny.addEventListener('input', function () { var v = parseFloat(String(u.ny.value).replace(',', '.')); if (v >= 0) { st.y = v; st.ytxt = ''; st.pre = ''; render(); } });
      Array.prototype.forEach.call(u.pills, function (b) { b.addEventListener('click', function () { preset(st, b.getAttribute('data-p')); if (S.side !== side) setSide(side); else render(); }); });
      u.reset.addEventListener('click', function () { resetSt(st); if (S.side !== side) setSide(side); else render(); });
    }
    bindUi(S.f, 'v'); if (hasBack) bindUi(S.b, 'h');

    // Ziehen und Größe per Ecke
    var drag = null;
    function pdown(e, mode) {
      var st = cur(); if (!st.img) return;
      e.preventDefault(); e.stopPropagation();
      var r = pa.getBoundingClientRect(), d = dims();
      drag = { mode: mode, st: st, sx: e.clientX, sy: e.clientY, x: st.x, y: st.y, w: st.w, k: d[0] / (r.width || 1) };
      mv.classList.add('is-drag');
      try { mv.setPointerCapture(e.pointerId); } catch (er) {}
    }
    mv.addEventListener('pointerdown', function (e) { pdown(e, e.target === mvH ? 'size' : 'move'); });
    mv.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var st = drag.st, d = dims(), dx = (e.clientX - drag.sx) * drag.k, dy = (e.clientY - drag.sy) * drag.k;
      if (drag.mode === 'move') {
        st.x = drag.x + dx; st.y = drag.y + dy;
        var snap = Math.abs(st.x + st.w / 2 - d[0] / 2) < 0.6;
        if (snap) st.x = (d[0] - st.w) / 2;
        guide.hidden = !snap;
      } else {
        st.w = drag.w + Math.max(dx, dy * (st.ratio || 1));
      }
      st.pre = ''; S.dragged = true;
      render();
    });
    function pup() { if (!drag) return; drag = null; mv.classList.remove('is-drag'); guide.hidden = true; render(); }
    mv.addEventListener('pointerup', pup); mv.addEventListener('pointercancel', pup);

    // Uploads
    function onFile(inp, st, side) {
      inp.addEventListener('change', function () {
        var f = inp.files && inp.files[0];
        if (st.url && st.img) { try { URL.revokeObjectURL(st.url); } catch (e) {} }
        st.url = ''; st.img = false; st.ratio = 0; st.file = !!f; st.ytxt = '';
        if (f && /^image\/(png|jpe?g|svg\+xml|webp|gif)$/.test(f.type)) {
          st.url = URL.createObjectURL(f); st.img = true;
          var im = new Image();
          im.onload = function () { st.ratio = im.naturalWidth && im.naturalHeight ? im.naturalWidth / im.naturalHeight : 1; resetSt(st); render(); };
          im.onerror = function () { st.img = false; resetSt(st); render(); };
          im.src = st.url;
        } else if (f) resetSt(st);
        if (f) { setTimeout(showPa, 0); if (side === 'h') blankImg(); setSide(side); } else render();
      });
    }
    onFile(inpF, S.f, 'v');
    if (hasBack) {
      onFile(inpB, S.b, 'h');
      backSw.addEventListener('click', function () { setTimeout(function () { setSide(backOn() ? 'h' : 'v'); }, 0); });
      Array.prototype.forEach.call(root.querySelectorAll('[data-sd-b]'), function (b) { b.addEventListener('click', function () { setSide('h'); }); });
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-sd-f]'), function (b) { b.addEventListener('click', function () { if (S.side !== 'v') setSide('v'); }); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-sd-thumb]'), function (b) { b.addEventListener('click', function () { if (S.side !== 'v') setSide('v'); }); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-sd-z]'), function (b) { b.addEventListener('click', function () { setTimeout(render, 0); }); });
    if (later) later.addEventListener('change', function () {
      if (!later.checked) return;
      [S.f, S.b].forEach(function (st) { st.url = ''; st.img = false; st.ratio = 0; st.file = false; });
      render();
    });
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();